import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[ridangoScrollIntoView]',
    exportAs: 'ridangoScrollIntoView'
})
export class RidangoScrollIntoViewDirective {
    constructor(private host: ElementRef<HTMLElement>) {}

    /**
     * Call this manually when you want scrolling.
     */
    public scrollTo(): void {
        const el = this.host.nativeElement;
        if (!el) return;

        this.performRobustScroll(el);
    }

    private async performRobustScroll(el: HTMLElement): Promise<void> {
        await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

        const modalEl = el.closest('ion-modal') as HTMLIonModalElement | null;
        let scrollEl: HTMLElement | null = null;

        try {
            const ionContent = modalEl?.querySelector('ion-content') as HTMLIonContentElement | null;
            if (ionContent?.getScrollElement) scrollEl = await ionContent.getScrollElement();
        } catch {
            // Best effort
        }

        if (!scrollEl)
            scrollEl =
                (el.closest('.inner-scroll, .scrollable') as HTMLElement) || (document.scrollingElement as HTMLElement);
        if (!scrollEl) return;

        const containerRect = scrollEl.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const currentScrollTop = scrollEl === document.scrollingElement ? window.scrollY : scrollEl.scrollTop;

        const elementTopWithinContainer = elRect.top - containerRect.top + currentScrollTop;
        const targetTop = elementTopWithinContainer;
        scrollEl.scrollTo({ top: targetTop, behavior: 'smooth' });
    }
}
